import clsx from 'clsx';

interface Props {
  className?: string;
  children: React.ReactNode;
}

function FormLabel({ className, children }: Props): JSX.Element {
  return (
    <div
      className={clsx(
        'mb-1 block text-sm font-medium text-gray-700',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default FormLabel;
